module.exports = __webpack_public_path__ + "img/gift-friend-bg.8958c341.png";